module.exports = __webpack_public_path__ + "img/expressage.632eaa38.png";